import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';

export function NotFound() {
  return (
    <div className="mx-auto mt-24 max-w-md px-4 text-center">
      <p className="text-sm font-medium text-muted-foreground">404</p>
      <h1 className="mt-2 text-lg font-semibold">Page not found</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        The page or record you are looking for does not exist.
      </p>
      <Button asChild className="mt-6" variant="outline">
        <Link to="/">Go to Home</Link>
      </Button>
    </div>
  );
}

export function Forbidden() {
  return (
    <div className="mx-auto mt-24 max-w-md px-4 text-center">
      <p className="text-sm font-medium text-muted-foreground">403</p>
      <h1 className="mt-2 text-lg font-semibold">You do not have access to this page</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Your role does not include this page. Ask a developer if you think it should.
      </p>
      <Button asChild className="mt-6" variant="outline">
        <Link to="/">Go to Home</Link>
      </Button>
    </div>
  );
}
